import { render, staticRenderFns } from "./Aspirantes.vue?vue&type=template&id=6b372664&scoped=true"
import script from "./Aspirantes.vue?vue&type=script&lang=js"
export * from "./Aspirantes.vue?vue&type=script&lang=js"
import style0 from "./Aspirantes.vue?vue&type=style&index=0&id=6b372664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b372664",
  null
  
)

export default component.exports